import script from "./SortCardDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SortCardDashboard.vue?vue&type=script&setup=true&lang=js"

import "./SortCardDashboard.vue?vue&type=style&index=0&id=f985b8ce&lang=scss"

const __exports__ = script;

export default __exports__